<template>
    <v-input class="w-full min-w-0 flex-1" no-margin hide-label type="text" name="search" placeholder="generic.search" v-model:value="model" />
</template>

<script setup lang="ts">
const model = defineModel<string>({ default: '' });
</script>
